import React, { JSX, useMemo } from "react";
import PillList from "components/atoms/PillList";
import { decodeHTMLEntities } from "assets/utils/helper";

type TagsItem = {
  id: string;
  displayName: string;
  fields: {
    hashvalue: { value: string };
    link: { value: { href: string } };
  };
};

type CategoriesItem = {
  id: string;
  displayName: string;
  fields: {
    hashvalue: { value: string };
    link: { value: { href: string } };
  };
};

type BlogCategoriesProps = {
  fields: {
    Tags?: Array<TagsItem>;
    Categories?: Array<CategoriesItem>;
  };
};

const fixAmpArtifacts = (text: string) => text.replace(/\bamp\b/gi, "&");
const toDisplayText = (raw?: string): string => {
  if (!raw) return "";
  return fixAmpArtifacts(
    decodeHTMLEntities(raw)
      .replace(/<[^>]*>/g, "") 
      .replace(/\s+/g, " ")
      .trim()
  );
};

const BlogCategories = ({ fields }: BlogCategoriesProps): JSX.Element => {
  const categories = fields?.Categories ?? [];
  const tags = fields?.Tags ?? [];

  const decodedCategories = useMemo(
    () =>
      categories.map((c) => ({
        ...c,
        displayName: toDisplayText(c.displayName),
      })),
    [categories]
  );

  const decodedTags = useMemo(
    () =>
      tags.map((t) => ({
        ...t,
        displayName: toDisplayText(t.displayName),
      })),
    [tags]
  );

  const pills = useMemo(
    () => [
      ...decodedCategories
        .filter(({ displayName }) => displayName?.trim().length > 0)
        .map(({ id, displayName }) => ({
          id,
          value: displayName,
          text: displayName,
          href: `/blog?category-tag=${encodeURIComponent(displayName.trim())}`,
        })),
      ...decodedTags
        .filter(({ displayName }) => displayName?.trim().length > 0)
        .map(({ id, displayName }) => ({
          id,
          value: displayName,
          text: displayName,
          href: `/blog?category-tag=${encodeURIComponent(displayName.trim())}`,
        })),
    ],
    [decodedCategories, decodedTags]
  );

  return (
    <div className="overhauled blog-pills content-wrapper">
      <h4>Explore more:</h4>
      <PillList type="category-tag" pills={pills} />
    </div>
  );
};

export default BlogCategories;
